import { render, staticRenderFns } from "./Invite.view.vue?vue&type=template&id=07bcc81d&scoped=true"
import script from "./Invite.view.vue?vue&type=script&lang=ts"
export * from "./Invite.view.vue?vue&type=script&lang=ts"
import style0 from "./Invite.view.vue?vue&type=style&index=0&id=07bcc81d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bcc81d",
  null
  
)

export default component.exports